import merge from 'lodash/merge.js';

import BaseSection from '@/store/modules/base/BaseSection.js';

export default merge(BaseSection, {
    autoImport: false,
});
